import { Dropdown, Menu, Avatar, Spin, Space, Tag, Button, Typography } from 'antd';
import React from 'react';
import { SettingOutlined, LogoutOutlined, UserOutlined, MoreOutlined, HomeOutlined, QuestionCircleOutlined, GlobalOutlined, InfoCircleOutlined, CloseOutlined } from '@ant-design/icons';
import styled from 'styled-components';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$1 = "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.index_menu__uxlXz .anticon {\n  margin-right: 8px;\n}\n.index_menu__uxlXz .ant-dropdown-menu-item {\n  min-width: 160px;\n}\n.index_right__27DLf {\n  display: flex;\n  float: right;\n  margin-left: auto;\n  padding-right: 32px;\n  overflow: hidden;\n}\n.index_right__27DLf .index_action__37xx1 {\n  display: flex;\n  align-items: center;\n  height: 100%;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n.index_right__27DLf .index_action__37xx1 > span {\n  vertical-align: middle;\n}\n.index_right__27DLf .index_action__37xx1:hover {\n  background: rgba(0, 0, 0, 0.025);\n}\n.index_right__27DLf .index_action__37xx1.opened {\n  background: rgba(0, 0, 0, 0.025);\n}\n.index_right__27DLf .index_search__Zhw0V:hover {\n  background: transparent;\n}\n.index_right__27DLf .index_account__qRMeW .index_avatar__3hDS0 {\n  color: rgba(0, 0, 0, 0.85);\n  vertical-align: top;\n  background: rgba(255, 255, 255, 0.85);\n}\n.index_right__27DLf .index_account__qRMeW .index_dropdown__3H5jB svg {\n  margin-right: 8px;\n}\n.index_dark__2qNaI .index_action__37xx1:hover {\n  background: #252a3d;\n}\n.index_dark__2qNaI .index_action__37xx1.opened {\n  background: #252a3d;\n}\n.index_shadow__ip0np {\n  box-shadow: rgba(0, 0, 0, 0.1) 0 10px 15px -3px, rgba(0, 0, 0, 0.05) 0 4px 6px -2px;\n}\n";
var styles$1 = {"menu":"index_menu__uxlXz","right":"index_right__27DLf","action":"index_action__37xx1","search":"index_search__Zhw0V","account":"index_account__qRMeW","avatar":"index_avatar__3hDS0","dropdown":"index_dropdown__3H5jB","dark":"index_dark__2qNaI","shadow":"index_shadow__ip0np"};
styleInject(css_248z$1);

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var classnames = {exports: {}};

/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/

(function (module) {
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
}(classnames));

var classNames = classnames.exports;

var css_248z = "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.index_container__27l-z > * {\n  margin-top: 8px;\n  background-color: #fff;\n  border-radius: 4px;\n  box-shadow: 0 6px 16px -8px rgba(0, 0, 0, 0.08), 0 9px 28px 0 rgba(0, 0, 0, 0.05), 0 12px 48px 16px rgba(0, 0, 0, 0.03);\n}\n@media screen and (max-width: 480px) {\n  .index_container__27l-z {\n    width: 100% !important;\n  }\n  .index_container__27l-z > * {\n    border-radius: 0 !important;\n  }\n}\n";
var styles = {"container":"index_container__27l-z"};
styleInject(css_248z);

const HeaderDropdown = ({
  overlayClassName: cls,
  ...restProps
}) => /*#__PURE__*/React.createElement(Dropdown, _extends({
  overlayClassName: classNames(styles.container, cls)
}, restProps));

/* eslint-disable no-useless-escape */
const reg = /(((^https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+(?::\d+)?|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/;
const isUrl = path => reg.test(path);
const getSsoUrl = () => {
  // get corresponding sso url, for example:
  // smb-dev.mobagel.com -> sso-dev.mobagel.com
  // smb.localhost.com -> sso.localhost.com
  // smb-demo.mobagel.com -> sso-demo.mobagel.com
  const domains = window.location.host.split('.');
  const subDomain = domains[0].split('-');
  subDomain[0] = 'sso';
  domains.shift();
  return `${window.location.protocol}//${subDomain.join('-')}.${domains.join('.')}`;
};

/**
 * 退出登录，并且将当前的 url 保存
 */
const loginOut = async onUserlogout => {
  const isDisableRedirect = await onUserlogout();

  if (!isDisableRedirect) {
    window.location.assign(`${getSsoUrl()}/login`);
  }
};

const AvatarDropdown = ({
  onUserlogout,
  formatMessage,
  currentUser,
  extendsAvatarDropdown = [],
  avatarHiddenList = []
}) => {
  const loading = /*#__PURE__*/React.createElement("span", {
    className: `${styles$1.action} ${styles$1.account}`
  }, /*#__PURE__*/React.createElement(Spin, {
    size: "small",
    style: {
      marginLeft: 8,
      marginRight: 8
    }
  }));

  if (!currentUser) {
    return loading;
  }

  if (!currentUser || !currentUser?.name) {
    return loading;
  }

  const menuHeaderDropdown = /*#__PURE__*/React.createElement(Menu, {
    className: styles$1.menu
  }, !avatarHiddenList.includes('setting') && /*#__PURE__*/React.createElement(Menu.Item, {
    key: "setting",
    onClick: () => window.location.assign(`${getSsoUrl()}/profile`)
  }, /*#__PURE__*/React.createElement(SettingOutlined, null), formatMessage({
    id: 'common.nav.settings'
  })), extendsAvatarDropdown.length > 0 && extendsAvatarDropdown.map(({
    Icon,
    label,
    onClick
  }) => {
    return /*#__PURE__*/React.createElement(Menu.Item, {
      key: "logout",
      onClick: onClick
    }, Icon || /*#__PURE__*/React.createElement("span", {
      style: {
        paddingLeft: '22px'
      }
    }, " "), label);
  }), !avatarHiddenList.includes('logout') && /*#__PURE__*/React.createElement(Menu.Item, {
    key: "logout",
    onClick: () => loginOut(onUserlogout)
  }, /*#__PURE__*/React.createElement(LogoutOutlined, null), formatMessage({
    id: 'common.nav.logout'
  })));
  return /*#__PURE__*/React.createElement(HeaderDropdown, {
    overlay: menuHeaderDropdown
  }, /*#__PURE__*/React.createElement("span", {
    className: `${styles$1.action} ${styles$1.account}`
  }, /*#__PURE__*/React.createElement(Avatar, {
    className: styles$1.avatar,
    icon: /*#__PURE__*/React.createElement(UserOutlined, null),
    alt: "avatar"
  }), currentUser.name));
};

const ServiceMenu = ({
  services,
  formatMessage,
  onTracking,
  exploreHiddenList = []
}) => {
  const appList = services.map(service => {
    return {
      name: formatMessage({
        id: `common.service.${service.serviceName}`
      }),
      url: service.externalDomain,
      onClick: service.onClick,
      serviceName: service.serviceName,
      Icon: service.Icon
    };
  });
  return /*#__PURE__*/React.createElement(Menu, {
    className: styles$1.shadow,
    mode: "inline"
  }, !exploreHiddenList.includes('home') && /*#__PURE__*/React.createElement(Menu.Item, {
    icon: /*#__PURE__*/React.createElement(HomeOutlined, null),
    onClick: () => {
      onTracking('nav-home');
      window.location.assign(`${getSsoUrl()}`);
    }
  }, formatMessage({
    id: 'common.nav.home'
  })), appList.map(app => {
    return /*#__PURE__*/React.createElement(Menu.Item, {
      key: app.name,
      onClick: () => {
        onTracking(`nav-${app.serviceName}`);

        if (typeof app.onClick === 'function') {
          app.onClick();
        } else {
          window.open(app.url);
        }
      }
    }, app.Icon, app.name);
  }));
};

const ExplorationDropdown = ({
  services = [],
  formatMessage,
  onTracking,
  exploreHiddenList = []
}) => {
  if (services.length === 0 && exploreHiddenList.includes('home')) {
    return null;
  }

  return /*#__PURE__*/React.createElement(HeaderDropdown, {
    overlay: /*#__PURE__*/React.createElement(ServiceMenu, {
      exploreHiddenList: exploreHiddenList,
      services: services,
      formatMessage: formatMessage,
      onTracking: onTracking
    }),
    placement: "bottomRight"
  }, /*#__PURE__*/React.createElement("span", {
    className: styles$1.action
  }, /*#__PURE__*/React.createElement(MoreOutlined, null)));
};

const QuestionMenu = ({
  formatMessage,
  onTracking,
  extendsInfoDropdown = [],
  infoHiddenList = []
}) => {
  return /*#__PURE__*/React.createElement(Menu, null, !infoHiddenList.includes('contact') && /*#__PURE__*/React.createElement(Menu.Item, {
    onClick: () => {
      onTracking('contact');
    }
  }, /*#__PURE__*/React.createElement("a", {
    href: "mailto:hello@8ndpoint.com",
    target: "_blank",
    rel: "noopener noreferrer"
  }, formatMessage({
    id: 'common.nav.contact'
  }))), !infoHiddenList.includes('faq') && /*#__PURE__*/React.createElement(Menu.Item, {
    onClick: () => {
      onTracking('faq');
      window.open('https://www.8ndpoint.com/faq');
    }
  }, formatMessage({
    id: 'common.nav.faq'
  })), extendsInfoDropdown.length > 0 && extendsInfoDropdown.map(({
    Icon,
    label,
    onClick
  }) => {
    return /*#__PURE__*/React.createElement(Menu.Item, {
      key: label,
      onClick: onClick
    }, Icon, label);
  }));
};

const InfoDropDwon = ({
  formatMessage,
  onTracking,
  extendsInfoDropdown = [],
  infoHiddenList = []
}) => {
  if (extendsInfoDropdown.length === 0 && infoHiddenList.includes('faq') && infoHiddenList.includes('contact')) {
    return null;
  }

  return /*#__PURE__*/React.createElement(HeaderDropdown, {
    overlay: /*#__PURE__*/React.createElement(QuestionMenu, {
      formatMessage: formatMessage,
      onTracking: onTracking,
      extendsInfoDropdown: extendsInfoDropdown,
      infoHiddenList: infoHiddenList
    }),
    placement: "bottomRight"
  }, /*#__PURE__*/React.createElement("span", {
    className: styles$1.action
  }, /*#__PURE__*/React.createElement(QuestionCircleOutlined, null)));
};

const DEFAULT_LANGS = [{
  lang: 'en-US',
  label: 'English'
}, {
  lang: 'zh-TW',
  label: '繁體中文'
}];

const SelectedLang = ({
  onUpdateLocale,
  extendLangsDropdown = []
}) => {
  const itemClick = item => {
    onUpdateLocale(item?.key, false);
  };

  const menu = /*#__PURE__*/React.createElement(Menu, {
    onClick: itemClick
  }, [...DEFAULT_LANGS, ...extendLangsDropdown].map(lang => /*#__PURE__*/React.createElement(Menu.Item, {
    key: lang?.lang
  }, /*#__PURE__*/React.createElement(Space, null, lang.label))));
  return /*#__PURE__*/React.createElement(HeaderDropdown, {
    overlay: menu,
    placement: "bottomCenter"
  }, /*#__PURE__*/React.createElement("span", {
    className: styles$1.action
  }, /*#__PURE__*/React.createElement(GlobalOutlined, null)));
};

const ENVTagColor = {
  dev: 'orange',
  test: 'green',
  pre: '#87d068'
};
const HeaderRight = ({
  layout,
  navTheme,
  versionTag,
  onUserlogout,
  formatMessage,
  currentUser,
  onTracking,
  services,
  extendsAvatarDropdown,
  avatarHiddenList,
  extendsInfoDropdown,
  infoHiddenList,
  exploreHiddenList,
  onUpdateLocale,
  isShowLang,
  extendLangsDropdown
}) => {
  let className = styles$1.right;

  if (navTheme === 'dark' && layout === 'top' || layout === 'mix') {
    className = `${styles$1.right}  ${styles$1.dark}`;
  }

  return /*#__PURE__*/React.createElement(Space, {
    className: className,
    size: 32
  }, /*#__PURE__*/React.createElement(InfoDropDwon, {
    formatMessage: formatMessage,
    onTracking: onTracking,
    extendsInfoDropdown: extendsInfoDropdown,
    infoHiddenList: infoHiddenList
  }), /*#__PURE__*/React.createElement(ExplorationDropdown, {
    formatMessage: formatMessage,
    services: services,
    onTracking: onTracking,
    exploreHiddenList: exploreHiddenList
  }), /*#__PURE__*/React.createElement(AvatarDropdown, {
    onUserlogout: onUserlogout,
    formatMessage: formatMessage,
    currentUser: currentUser,
    extendsAvatarDropdown: extendsAvatarDropdown,
    avatarHiddenList: avatarHiddenList
  }), versionTag && /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Tag, {
    color: ENVTagColor[versionTag]
  }, versionTag)), isShowLang && /*#__PURE__*/React.createElement(SelectedLang, {
    onUpdateLocale: onUpdateLocale,
    extendLangsDropdown: extendLangsDropdown
  }));
};

styled.div`
  padding-bottom: 8px;
`;
styled.div`
  display: flex;
`;
const StyledButton = styled(Button)`
  border-radius: 0;
  padding-left: 16px;
  padding-right: 16px;
  border-width: 0px;
  margin-right: 8px;
  &:last-child {
    margin-right: 0;
  }
`;
const NotificationContainer = styled.div`
  padding: 0 16px;
  min-height: 60px;
  display: flex;
  align-items: center;
  background: #fff;
  box-sizing: border-box;
  overflow: hidden;
  ${props => props.styles ? props.styles : ''};
`;
const NoticationTextContainer = styled.div`
  display: flex;
  padding: 0 32px;
  flex: 1 1 auto;
  overflow: hidden;
  > .ant-typography {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
const NoticationBtnContainer = styled.div`
  display: flex;
  align-items: center;
  & .ant-btn {
    height: 36px;
    margin-right: 16px;
  }
  & .ant-btn-link {
    margin-right: 0;
  }
`;
const StyledInfoCircleOutlined = styled(InfoCircleOutlined)`
  margin-left: 8px;
`;
const StyledCloseOutlined = styled(CloseOutlined)``;

const {
  Text
} = Typography;
const NotificationBar = ({
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onCloseBanner = () => {},
  elemRef,
  message,
  cancelButtonLabel,
  cancelButtonProp,
  confirmButtonLabel,
  confirmButtonProp,
  isShowWarningIcon = true,
  isShowCloseButton = true,
  styles
}) => {
  return /*#__PURE__*/React.createElement(NotificationContainer, {
    ref: elemRef,
    className: "notification-container",
    styles: styles
  }, isShowWarningIcon && /*#__PURE__*/React.createElement(StyledInfoCircleOutlined, null), /*#__PURE__*/React.createElement(NoticationTextContainer, {
    className: "message-container"
  }, /*#__PURE__*/React.createElement(Text, null, message)), /*#__PURE__*/React.createElement(NoticationBtnContainer, {
    className: "button-container"
  }, Boolean(cancelButtonLabel) && /*#__PURE__*/React.createElement(StyledButton, _extends({}, cancelButtonProp, {
    className: "cancel-btn"
  }), cancelButtonLabel), Boolean(confirmButtonLabel) && /*#__PURE__*/React.createElement(StyledButton, _extends({
    type: "primary"
  }, confirmButtonProp, {
    className: "confirm-btn"
  }), confirmButtonLabel), isShowCloseButton && /*#__PURE__*/React.createElement(Button, {
    onClick: onCloseBanner,
    type: "link",
    shape: "circle",
    className: "close-btn"
  }, /*#__PURE__*/React.createElement(StyledCloseOutlined, null))));
};

export { HeaderRight, NotificationBar, getSsoUrl, isUrl };
